// Editorial links only: local paths or HTTPS, never executable or protocol-relative URLs.
const isBlogLink = href => {
  if (typeof href !== 'string' || /[\s\\]/.test(href)) return false;
  if (/^\/(?!\/)/.test(href)) return true;
  if (!href.startsWith('https://')) return false;
  try {
    const url = new URL(href);
    return Boolean(url.hostname) && !url.username && !url.password;
  } catch {
    return false;
  }
};
module.exports = isBlogLink;
